import React from 'react';
import { InfoMessage } from 'components';
import styled from 'styled-components/macro';
import { Colors } from '@cognite/cogs.js';
import { RuleRunStatus } from 'types/dt-graphql-apollo-v2';
import { RunsHistory } from './RunsHistory';

export const ViewRunsPage = ({
  runs,
  selectedRun,
  setSelectedRun,
}: {
  runs: RuleRunStatus[];
  selectedRun?: RuleRunStatus;
  setSelectedRun: (run: RuleRunStatus) => void;
}) => {
  if (runs.length === 0)
    return <InfoMessage type="Alarm">No completed runs yet</InfoMessage>;

  return (
    <TabPaneContainer>
      <RunsHistory
        title="Runs history"
        runHistory={runs}
        selectedRun={selectedRun}
        setSelectedRun={setSelectedRun}
        showPagination
      />
    </TabPaneContainer>
  );
};

const TabPaneContainer = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fill, 1fr);
  margin-top: 1rem;

  .selected-run {
    transition: all 250ms linear;
    background: var(--cogs-midblue-8);
    box-shadow: 0px 0px 0px 1px var(--cogs-midblue-4);

    &:hover {
      background: var(--cogs-midblue-6);
    }
  }
  .disabled {
    pointer-events: none;
  }
`;
